// Modulo di richiesta sempre aperto del singolo Servizio
// (template-parts/servizio/richiesta.php): a differenza del form
// "Parliamone" dell'archivio Servizi (componente condiviso "cta-panel", vedi
// assets/js/cta-panel.js) qui non c'è nessun pannello da aprire/chiudere,
// solo la validazione live e l'invio.
// Riusa gli stessi helper di stato/messaggio e gli stessi pattern nome/email
// di assets/js/contatti.js, con in più azienda (obbligatoria) e
// telefono/città (facoltativi, validati solo se compilati). Il messaggio è
// obbligatorio (stessa lunghezza minima del form Contatti della home);
// partecipanti resta l'unico campo di testo libero facoltativo.
import {
    setMessage,
    setFieldState,
    NAME_PATTERN,
    EMAIL_PATTERN,
    MESSAGE_MIN_LENGTH,
    AZIENDA_PATTERN,
    TELEFONO_PATTERN,
    CITTA_PATTERN,
} from "./contatti";

function initServizioRichiestaForm(form) {
    const submitButton = form.querySelector(".contatti__submit");
    const messageEl = form.querySelector("[data-contatti-message]");
    const nomeInput = form.querySelector('[name="nome"]');
    const aziendaInput = form.querySelector('[name="azienda"]');
    const emailInput = form.querySelector('[name="email"]');
    const telefonoInput = form.querySelector('[name="telefono"]');
    const cittaInput = form.querySelector('[name="citta"]');
    const messaggioInput = form.querySelector('[name="messaggio"]');
    const privacyInput = form.querySelector('[name="privacy"]');

    if (!nomeInput || !aziendaInput || !emailInput || !messaggioInput || !privacyInput) {
        return;
    }

    const touched = new Set();

    function validate() {
        const nomeValid = NAME_PATTERN.test(nomeInput.value.trim());
        const aziendaValid = AZIENDA_PATTERN.test(aziendaInput.value.trim());
        const emailValid = EMAIL_PATTERN.test(emailInput.value.trim());
        // Telefono e città sono facoltativi: un campo lasciato vuoto è
        // valido, il pattern si applica solo se il visitatore lo ha compilato.
        const telefonoValid = !telefonoInput.value.trim() || TELEFONO_PATTERN.test(telefonoInput.value.trim());
        const cittaValid = !cittaInput.value.trim() || CITTA_PATTERN.test(cittaInput.value.trim());
        const messaggioValid = messaggioInput.value.trim().length >= MESSAGE_MIN_LENGTH;
        const privacyValid = privacyInput.checked;

        setFieldState(form, "nome", nomeInput, nomeValid, touched.has("nome"));
        setFieldState(form, "azienda", aziendaInput, aziendaValid, touched.has("azienda"));
        setFieldState(form, "email", emailInput, emailValid, touched.has("email"));
        setFieldState(form, "telefono", telefonoInput, telefonoValid, touched.has("telefono"));
        setFieldState(form, "citta", cittaInput, cittaValid, touched.has("citta"));
        setFieldState(form, "messaggio", messaggioInput, messaggioValid, touched.has("messaggio"));
        setFieldState(form, "privacy", privacyInput, privacyValid, touched.has("privacy"));

        return nomeValid && aziendaValid && emailValid && telefonoValid && cittaValid && messaggioValid && privacyValid;
    }

    // Il submit resta sempre focalizzabile/abilitato, vedi contatti.js per il perché.
    function focusFirstInvalid() {
        const firstInvalid = form.querySelector(".is-invalid");

        if (firstInvalid) {
            firstInvalid.focus();
        }
    }

    [
        [nomeInput, "nome"],
        [aziendaInput, "azienda"],
        [emailInput, "email"],
        [telefonoInput, "telefono"],
        [cittaInput, "citta"],
        [messaggioInput, "messaggio"],
    ].forEach(([input, name]) => {
        if (!input) {
            return;
        }

        input.addEventListener("input", () => {
            touched.add(name);
            validate();
        });
        input.addEventListener("blur", () => {
            touched.add(name);
            validate();
        });
    });

    privacyInput.addEventListener("change", () => {
        touched.add("privacy");
        validate();
    });

    validate();

    form.addEventListener("submit", async (event) => {
        event.preventDefault();

        touched.add("nome");
        touched.add("azienda");
        touched.add("email");
        touched.add("telefono");
        touched.add("citta");
        touched.add("messaggio");
        touched.add("privacy");

        if (!validate()) {
            setMessage(messageEl, "Controlla i campi evidenziati e correggi gli errori indicati.", "error");
            focusFirstInvalid();
            return;
        }

        const settings = (window.Castro && window.Castro.settings) || {};
        const formData = new FormData(form);

        const payload = {
            nome: formData.get("nome") || "",
            email: formData.get("email") || "",
            messaggio: formData.get("messaggio") || "",
            sito_web: formData.get("sito_web") || "",
            nonce: settings.contattiNonce || "",
            sorgente: formData.get("sorgente") || "",
            azienda: formData.get("azienda") || "",
            telefono: formData.get("telefono") || "",
            partecipanti: formData.get("partecipanti") || "",
            citta: formData.get("citta") || "",
            servizio_id: formData.get("servizio_id") || "",
        };

        submitButton.disabled = true;
        submitButton.classList.add("is-loading");
        setMessage(messageEl, "", null);

        try {
            const response = await fetch(`${settings.api_url}castro/v1/contatti`, {
                method: "POST",
                credentials: "same-origin",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                setMessage(messageEl, data.message, "success");
                form.reset();
                touched.clear();
                validate();
            } else {
                setMessage(messageEl, data.message || "Si è verificato un errore, riprova più tardi.", "error");
                validate();
            }
        } catch (error) {
            setMessage(messageEl, "Impossibile inviare la richiesta, controlla la connessione e riprova.", "error");
            validate();
        } finally {
            // Vedi contatti.js: va sempre rimosso a fine richiesta, non lasciato al risultato della validazione.
            submitButton.disabled = false;
            submitButton.classList.remove("is-loading");
        }
    });
}

export function initServizioRichiesta() {
    document.querySelectorAll("[data-servizio-richiesta-form]").forEach(initServizioRichiestaForm);
}
